import { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { About } from "./components/about";
import { Features } from "./components/features";
import { Header } from "./components/header";
import { Navigation } from "./components/navigation";
import { Services } from "./components/services";
// import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
// import { Team } from "./components/Team";
import { useTranslation } from "react-i18next";
import "./App.css";
import { LanguageProvider } from "./Context/LanguageContext";
import Banner from "./components/Banner";
import ContactButton from "./components/ContactButton";
import { Career } from "./components/career";
import { Contact } from "./components/contact";
import ThankYou from "./pages/thank-you-page/ThankYou";

// ✅ Layout Component (Navigation + Header + Footer)
const Layout = ({ children, headerData }) => {
  return (
    <div className="main-layout">
      <Navigation />

      {children}
      <div id="footer">
        <div className="container text-center">
          Copyright © {new Date().getFullYear()} GPITCO. All rights reserved.
        </div>
      </div>
      <ContactButton type="call" />
      <ContactButton />
    </div>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const { i18n } = useTranslation();

  let rtl = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Home Page */}
            <Route
              path="/"
              element={
                <Layout headerData={landingPageData.Header}>
                  <Header data={landingPageData.Header} />
                  <Features data={landingPageData.Features} />
                  <About data={landingPageData.About} />
                  <Banner rtl={rtl} />
                  <Services data={landingPageData.Services} />
                  <Testimonials data={landingPageData.Testimonials} />
                  <Contact data={landingPageData.Contact} />
                  <Career />
                </Layout>
              }
            />

            {/* Thank You Page */}
            <Route
              path="/thank-you"
              element={
                <Layout>
                  <ThankYou />
                </Layout>
              }
            />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
